"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.podcastOidhl = void 0;
exports.podcastOidhl = {
    logos: {
        memoresaLogoName: "logo_bright.png",
        memoresaLogotypeName: "logotype_bright.png",
    },
};
